import { Link } from "react-router-dom";
import { Flame, ExternalLink } from "lucide-react";
import { PRACTICE, FOOTER_LINKS } from "../data/site";

export default function Footer() {
    const half = Math.ceil(FOOTER_LINKS.length / 2);
    const cols = [FOOTER_LINKS.slice(0, half), FOOTER_LINKS.slice(half)];

    const renderItem = (item) =>
        item.external ? (
            <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-sm text-amber-100/60 transition-colors hover:text-amber-300"
            >
                {item.label}
                <ExternalLink className="h-3 w-3" />
            </a>
        ) : (
            <Link
                key={item.label}
                to={item.to}
                className="text-sm text-amber-100/60 transition-colors hover:text-amber-300"
            >
                {item.label}
            </Link>
        );

    return (
        <footer
            data-testid="footer"
            className="relative border-t border-amber-500/15 bg-[#150e08]"
        >
            <div className="mx-auto w-full max-w-6xl px-6 py-16">
                <div className="grid gap-12 md:grid-cols-[1.4fr_1fr]">
                    <div>
                        <div className="flex items-center gap-2.5">
                            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-amber-500/15 ring-1 ring-amber-500/40">
                                <Flame className="h-4 w-4 text-amber-400" />
                            </span>
                            <span className="font-serif text-lg text-amber-50">
                                {PRACTICE.name}
                            </span>
                        </div>
                        <p className="mt-5 max-w-md text-sm leading-relaxed text-amber-100/60">
                            Play therapy, EMDR, and trauma-informed care for
                            children, teens, and adults — plus the Sandi &
                            Clammy books and Neuro & the 'Ception Force Friends.
                        </p>
                        <p className="mt-5 text-sm text-amber-100/55">
                            {PRACTICE.address}
                        </p>
                        <p className="mt-4 max-w-md text-xs leading-relaxed text-amber-100/35">
                            This website stores no health information.
                            Scheduling, intake forms, and client accounts live
                            securely on Headway, a HIPAA-compliant platform.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 gap-x-6 gap-y-3 md:justify-items-end">
                        {cols.map((col, i) => (
                            <div
                                key={col.map((c) => c.label).join("|") || `col-${i}`}
                                className="flex flex-col gap-3"
                            >
                                {col.map(renderItem)}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-14 flex flex-col gap-3 border-t border-amber-500/10 pt-8 text-xs text-amber-100/40 sm:flex-row sm:items-center sm:justify-between">
                    <p>© 2026 {PRACTICE.name}. All rights reserved.</p>
                    <p className="text-amber-200/45">
                        In crisis? Call or text{" "}
                        <span className="font-semibold text-amber-300">988</span>{" "}
                        (Suicide & Crisis Lifeline) — this site is not monitored
                        for emergencies.
                    </p>
                </div>
            </div>
        </footer>
    );
}
